export default __webpack_public_path__ + "static/media/newsletter3.10443b9f.jpg";